export const enum CRUDOperation {
  CREATE,
  READ,
  UPDATE,
  DELETE,
  UPDATE_AI
}
